<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark border-bottom border-body">
    <div class="container">
      <a class="navbar-brand" href="/">CHALAN-PRO</a>
      <!-- Add hamburger button -->
      <button class="navbar-toggler" type="button" @click="toggleNavbar" aria-controls="navbarNav" aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div :class="['collapse', 'navbar-collapse', { 'show': isNavbarOpen }]" id="navbarNav">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item" v-for="(item, index) in menuItems" :key="index">
            <router-link :to="item.route" class="nav-link" @click="closeNavbar">{{ item.text }}</router-link>
          </li>
          <!-- Display Login or Logout depending on authentication status -->
          <li class="nav-item" v-if="!isLoggedIn">
            <router-link to="/login" class="nav-link" @click="closeNavbar">Log In</router-link>
          </li>
          <li class="nav-item" v-else>
            <router-link to="/logout" class="nav-link" @click="logout">Log Out</router-link>
          </li>
          <li class="nav-item" v-if="isLoggedIn">
            <span class="nav-link">Welcome, {{ userName }}</span>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      isLoggedIn: false,
      isNavbarOpen: false,
      menuItems: [
        { text: 'Dashboard', route: '/' },
        { text: 'Contracts', route: '/contracts' },
        { text: 'Piece Work Prices', route: '/work-prices' },
        { text: 'Communities Map', route: '/map' },
       // { text: 'Weekly Summary Report', route: '/weekly-summary-list' },
        { text: 'About', route: '/about' },
      ],
      userName: ''
    };
  },
  mounted() {
    this.checkUserIdentity();
  },
  methods: {
    checkUserIdentity() {
      // Lógica para verificar el estado de autenticación
      const token = localStorage.getItem('authToken');
      this.isLoggedIn = !!token; // Establece isLoggedIn basado en la existencia del token
      if (this.isLoggedIn) {
        this.getAuthenticatedUser().then(user => {
          if (user) {
            this.userName = user.username; // Asigna el nombre de usuario
          }
        });
      }
    },

    logout() {
      localStorage.removeItem('authToken');
      localStorage.removeItem('userPermissions');
      this.isLoggedIn = false;
      this.$router.push('/login');
      this.closeNavbar();
    },
    toggleNavbar() {
      this.isNavbarOpen = !this.isNavbarOpen;
    },
    closeNavbar() {
      this.isNavbarOpen = false;
    }
  },
  watch: {
    $route() {
      this.checkUserIdentity();
    }
  }
};
</script>

<style scoped>
.navbar {
  background-color: #4e73df;
  background-image: linear-gradient(180deg, #395ecb 35%, #0c35b1 100%);
}

nav {
  padding: 12px;
}

nav a {
  font-weight: bold;
  color: #e5e8eb;
}

nav .nav-link.router-link-exact-active {
  color: #ff931e;
}

@media (max-width: 991.98px) {
  .navbar-nav {
    padding-top: 1rem;
  }

  .nav-item {
    padding: 0.5rem 0;
  }
}
</style>